import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterRadioSelect } from '../base/BaseFilterRadioSelect';

interface IMeterEnrollmentFilterSelectProps {
    value: string | null;
    onChange: (value: string | null) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
}

export const MeterEnrollmentFilterSelect: React.FC<IMeterEnrollmentFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 80,
    disabled = false,
    options,
}) => {
    return (
        <BaseFilterRadioSelect
            resizable={false}
            showClear={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
